import { render, staticRenderFns } from "./LeadTakeDialog.vue?vue&type=template&id=2262d8d0"
import script from "./LeadTakeDialog.vue?vue&type=script&lang=ts"
export * from "./LeadTakeDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports